/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { List } from "immutable";

import SpinnerSVG from "static/spinner.svg";
import DownloadLayout from "./DownloadLayout";
import { columnOrder } from "./DownloadCommon";
import * as actions from "../actions";
import downloadViewStateToProps from "../selectors";

const removeDuplicates = arr => [...new Set(arr)];

const DownloadView = props => {
  const defaultCols = useRef([...columnOrder]);

  const [state, setState] = useState({
    downloadModalVisible: false,
    downloadFileType: "",
    tableFilter: "",
    apiUrlClicked: false,
    cols: [...columnOrder]
  });

  const gridRef = useRef();
  const isMounted = useRef(true);

  useEffect(() => {
    document.title = "Download";

    const fetchData = async () => {
      if (!props.sampleOptions.length) {
        await props.actions.fetchDisplayColumns();
        await props.actions.fetchSampleTypes();

        if (isMounted.current) {
          props.actions.rehydrate();
        }
      }
      if (props.location.search !== "?" && props.location.search !== "") {
        const urlParams = new URLSearchParams(
          props.location.search.replace("?", "")
        );
        const sample = urlParams.get("sample");
        // eslint-disable-next-line no-use-before-define
        await changeSampleType(sample);
        if (isMounted.current) {
          props.actions.updateFiltersFromQuery(urlParams);
        }
      }
    };

    if (props.organization && !props.chips.organization) {
      props.actions.setChips({
        field: "organization",
        chips: [props.organization]
      });
    }
    if (props.workarea && !props.chips.work_area) {
      props.actions.setChips({
        field: "work_area",
        chips: [props.workarea]
      });
    }

    fetchData();

    return () => {
      isMounted.current = false;
    };
  }, []);

  const clearForm = () => {
    props.actions.clearSampleType();
  };

  const changeSampleType = async val => {
    setState(prevState => ({ ...prevState, apiUrlClicked: false }));
    props.actions.setSampleType(val);
    await props.actions.fetchMetaData();
    props.actions.fetchAutcomplete();
    setState(prevState => ({
      ...prevState,
      cols: defaultCols.current
    }));
    props.actions.fetchRecordCount();
  };

  const handleAdvValueChange = (index, value) => {
    props.actions.advValueChange({ index, value });
  };

  const handleAdvOperatorChange = (index, operator) => {
    props.actions.advOperatorChange({ index, operator });
  };

  const handleAdvColChange = (index, col) => {
    props.actions.advColChange({ index, col });
  };

  const handleTimeZoneChange = value => {
    props.actions.timeZoneChange({ value });
    props.actions.fetchRecordCount();
  };

  const handleAdvFilterSave = index => {
    props.actions.advSave(index);
    props.actions.fetchRecordCount();
  };

  const handleAdvFilterRemove = index => {
    props.actions.advRemove(index);
    if (props.advancedFilters[index].saved) {
      props.actions.fetchRecordCount();
    }
  };

  const handleRefreshSummary = () => {
    props.actions.fetchRecordCount();
  };
  return (
    <DownloadLayout
      {...props}
      storeGridRef={ref => {
        gridRef.current = ref;
      }}
      gridRef={gridRef.current}
      addColumnToView={str => {
        if (!state.cols.includes(str)) {
          setState(prevState => ({
            ...prevState,
            cols: [...prevState.cols, str]
          }));
        }
      }}
      removeColumnFromView={str => {
        const index = state.cols.indexOf(str);
        if (!columnOrder.includes(str) && index > -1) {
          setState(prevState => ({
            ...prevState,
            cols: prevState.cols.filter((el, i) => i !== index)
          }));
        }
      }}
      onStartDateFilterChange={dateStr => {
        const dt = moment(dateStr);
        if (!dt || (dt && !moment(dt).isValid())) {
          props.actions.setStartDateFilter("");
          props.actions.fetchRecordCount();
        } else if (dt && dt.isValid()) {
          props.actions.setStartDateFilter(dt.format("YYYY-MM-DD"));
          props.actions.fetchRecordCount();
        }
      }}
      onEndDateFilterChange={dateStr => {
        const dt = moment(dateStr);
        if (!dt || (dt && !moment(dt).isValid())) {
          props.actions.setEndDateFilter("");
          props.actions.fetchRecordCount();
        } else if (dt && dt.isValid()) {
          props.actions.setEndDateFilter(dt.format("YYYY-MM-DD"));
          props.actions.fetchRecordCount();
        }
      }}
      gridIsLoaded={typeof gridRef.current === "object"}
      downloadModalVisible={state.downloadModalVisible}
      downloadFileType={state.downloadFileType}
      downloadModalSetVisible={(downloadModalVisible, downloadFileType = "") =>
        setState(prevState => ({
          ...prevState,
          downloadModalVisible,
          downloadFileType
        }))
      }
      tableFilter={state.tableFilter}
      setTableFilter={(e, v) =>
        setState(prevState => ({ ...prevState, tableFilter: v }))
      }
      cols={state.cols}
      setCols={cols => setState(prevState => ({ ...prevState, cols }))}
      onSummaryRefresh={() => handleRefreshSummary()}
      // onDownloadTypeSelect={(e, i, value) =>     // handleDownloadTypeSelect is not defined? is it not used here?
      //   handleDownloadTypeSelect(value)
      // }
      onClearForm={() => clearForm()}
      onSampleTypeChange={e => changeSampleType(e)}
      onPreviewClick={() => {
        setState(prevState => ({ ...prevState, apiUrlClicked: false }));
        props.actions.setShowPreview(true);
        if (gridRef.current) gridRef.current.api.purgeInfiniteCache();
      }}
      onAdvRemoveFilter={i => handleAdvFilterRemove(i)}
      onAdvSaveFilter={i => handleAdvFilterSave(i)}
      onAdvValueChange={(i, v) => handleAdvValueChange(i, v)}
      onAdvOperatorChange={(i, v) => handleAdvOperatorChange(i, v)}
      onAdvColChange={(i, v) => handleAdvColChange(i, v)}
      onTimeZoneChange={v => handleTimeZoneChange(v)}
      apiUrlClicked={state.apiUrlClicked}
      onApiURlClick={() =>
        setState(prevState => ({
          apiUrlClicked: !prevState.apiUrlClicked,
          cols: prevState.cols
        }))
      }
      onSampleSearchClear={() => props.actions.setSampleSearch([])}
      onRowCountChange={(e, i, v) => {
        props.actions.setPreviewRowCount(v);
        if (props.preview.length) props.actions.fetchPreview();
      }}
      setSearchText={(field, text) => {
        props.actions.setSearchText({ field, text });
      }}
      changeChip={(field, chips) => {
        props.actions.setChips({
          field,
          chips: removeDuplicates(chips)
        });
        props.actions.fetchRecordCount();
      }}
      getColumnDefs={() => {
        const { displayColumns, columnNames, sampleMetaData } = props;
        const { cols } = state;

        // Aggrid doesn't distinguish between false and null by default
        // so we need this custom renderer
        const boolFormatter = value => {
          if (value) {
            return "TRUE";
          }
          if (value === false) {
            return "FALSE";
          }
          return null;
        };

        // add your custom data type renderer here
        const getValueFormatter = params => {
          const { data, value, column, colDef } = params;
          if (!data && column.left === 0)
            return <SpinnerSVG width={25} height={25} />;

          const col = colDef.field;
          const type = sampleMetaData[col].udt_name;
          let formatted;

          switch (type) {
            case "bool":
              formatted = boolFormatter(value);
              break;
            default:
              formatted = value;
          }
          return <span>{formatted}</span>;
        };

        return columnNames.map(col => {
          const displayCol = displayColumns.get(col);

          return {
            filter: "text",
            menuTabs: [],
            headerName: (displayCol && displayCol.display_column) || col,
            field: col,
            cellRendererFramework: getValueFormatter,
            editable: false,
            hide: !cols?.includes(col) || false
          };
        });
      }}
    />
  );
};

DownloadView.propTypes = {
  organization: PropTypes.string,
  workarea: PropTypes.string,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired,
  sampleIDSearch: PropTypes.arrayOf(PropTypes.string).isRequired,
  preview: PropTypes.arrayOf(PropTypes.object).isRequired,
  sampleOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  displayColumns: PropTypes.object.isRequired,
  columnNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  sampleMetaData: PropTypes.object.isRequired,
  filteredDownloadData: PropTypes.instanceOf(List).isRequired,
  chips: PropTypes.object.isRequired,
  advancedFilters: PropTypes.arrayOf(PropTypes.shape({ saved: PropTypes.bool }))
    .isRequired,
  actions: PropTypes.shape({
    fetchAutcomplete: PropTypes.func.isRequired,
    setSearchText: PropTypes.func.isRequired,
    setChips: PropTypes.func.isRequired,
    setShowPreview: PropTypes.func.isRequired,
    advRemove: PropTypes.func.isRequired,
    advSave: PropTypes.func.isRequired,
    advColChange: PropTypes.func.isRequired,
    timeZoneChange: PropTypes.func.isRequired,
    advOperatorChange: PropTypes.func.isRequired,
    advValueChange: PropTypes.func.isRequired,
    setSampleSearch: PropTypes.func.isRequired,
    fetchDisplayColumns: PropTypes.func.isRequired,
    setPreviewRowCount: PropTypes.func.isRequired,
    fetchPreview: PropTypes.func.isRequired,
    fetchMetaData: PropTypes.func.isRequired,
    fetchRecordCount: PropTypes.func.isRequired,
    fetchSampleTypes: PropTypes.func.isRequired,
    setSampleType: PropTypes.func.isRequired,
    setStartDateFilter: PropTypes.func.isRequired,
    setEndDateFilter: PropTypes.func.isRequired,
    rehydrate: PropTypes.func.isRequired,
    clearSampleType: PropTypes.func.isRequired,
    updateFiltersFromQuery: PropTypes.func.isRequired,
    toggleAdvancedSearch: PropTypes.func.isRequired,
    downloadAdvSearchUpdate: PropTypes.func.isRequired,
    setFilterOpen: PropTypes.func.isRequired
  }).isRequired,
  filterOpen: PropTypes.bool.isRequired
};

DownloadView.defaultProps = {
  organization: "",
  workarea: ""
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default withRouter(
  connect(downloadViewStateToProps, mapDispatchToProps)(DownloadView)
);
